import { listAnatomy as parts } from "@chakra-ui/anatomy";
var baseStyleIcon = {
  marginEnd: "0.5rem",
  display: "inline",
  verticalAlign: "text-bottom"
};
var baseStyle = {
  container: {},
  item: {},
  icon: baseStyleIcon
};
export default {
  parts: parts.keys,
  baseStyle
};
//# sourceMappingURL=list.js.map